import {initInputStateSwitch} from "./input.state-switch";
import {initAHrefLightbox} from "./a[href*='#lightbox']";
import {initFormNameChangeCity} from "./form[name='change-city']";
import {initAsideSidebar} from "./aside.sidebar";
import {initAnchorsSliding} from "./a[href^='#']";
import {initSliders} from "./div.slider-wrapper";
import {initDivLightboxFirstScreen} from "./div.lightbox.first-screen";
import {initDivMap} from "./div.map";
import {initAShowSidebarButton} from "./a.show-sidebar-button";
import {initDivVirtualTour} from "./div.virtual-tour";

export const initElements = () => {
	initInputStateSwitch();
	initAHrefLightbox();
	initFormNameChangeCity();
	initAsideSidebar();
	initAnchorsSliding();
	initDivMap();
	initSliders();
	initDivLightboxFirstScreen();
	initAShowSidebarButton();
	initDivVirtualTour();
};
